export const config = {
  title: 'AA Natural Landscaping Corp | Expert Landscaping Services in Miami Gardens, FL',
  meta: {
    description:
      'AA Natural Landscaping Corp offers professional lawn maintenance, tree trimming, garden design, artificial turf installation, and more in Miami Gardens, FL. Transform your outdoor space with our expert team.',
    keywords: [
      'Landscaping Services Miami Gardens',
      'Lawn Maintenance',
      'Tree Trimming',
      'Garden Design',
      'Artificial Turf Installation',
      'Garden Decorations',
      'AA Natural Landscaping Corp',
    ],
    author: 'AA Natural Landscaping Corp',
    canonicalUrl: 'https://aanaturallandscaping.com/',
  },
  sections: {
    header: {
      businessName: 'AA Natural Landscaping Corp',
    },
    sectionB: {
      heroTitle: 'AA Natural Landscaping Corp',
      heroSubtitle: 'Transforming Outdoor Spaces in Miami Gardens, FL',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '7864134932',
      phoneLabel: '(786) 413-4932',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1324918160/photo/professional-gardener-trimming-hedge.jpg?s=612x612&w=0&k=20&c=zumBbqam7P2pNpoGMrca4RhZGWW7zfRDUDE2zqABJTs=',
      cardData: [
        {
          title: 'Lawn Maintenance',
          description:
            'Keep your lawn healthy and pristine with our professional maintenance services.',
        },
        {
          title: 'Tree Trimming',
          description:
            'Enhance the beauty and safety of your property with expert tree trimming.',
        },
        {
          title: 'Garden Design',
          description:
            'Create a stunning garden tailored to your preferences and space.',
        },
      ],
      description:
        'At AA Natural Landscaping Corp, we specialize in transforming outdoor spaces with services like lawn maintenance, tree trimming, garden design, artificial turf installation, and more. Our dedicated team in Miami Gardens, FL, ensures top-quality results for every project.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our comprehensive range of landscaping services designed to enhance your outdoor living experience.',
      cards: [
        {
          title: 'Lawn Maintenance',
          description:
            'Regular mowing, trimming, fertilizing, and weed control to keep your lawn lush and green.',
          imageSrc: 'https://media.istockphoto.com/id/1203042812/photo/worker-mowing-tall-grass-with-electric-or-petrol-lawn-trimmer-in-city-park-or-backyard.jpg?s=612x612&w=0&k=20&c=s2WolfHZfiPxho7IKlRQEWo9-oIFzLkoDpo6wk_zK4w=',
          imageAlt: 'Lawn Maintenance',
        },
        {
          title: 'Tree Trimming',
          description:
            'Professional pruning and shaping to promote healthy growth and aesthetic appeal of your trees.',
          imageSrc: 'https://media.istockphoto.com/id/174532200/photo/arborist-up-a-tree.jpg?s=612x612&w=0&k=20&c=xbGSP8KMrqKp5ytbkwSADbBourZ7_hWZtkzvw5PMZrs=',
          imageAlt: 'Tree Trimming',
        },
        {
          title: 'Garden Design',
          description:
            'Custom garden layouts and plant selections to create your ideal outdoor sanctuary.',
          imageSrc: 'https://media.istockphoto.com/id/1370727080/photo/professional-gardener-trimming-hedge-with-power-saw.jpg?s=612x612&w=0&k=20&c=uKxBUEdbpbLHbTimJKKcmcYUkM-paauw4oX6_n2kdUs=',
          imageAlt: 'Garden Design',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Artificial Turf Installation',
        'Walkway Landscaping',
        'Driveway Landscaping',
        'Garden Decorations',
        'Tree and Shrub Pruning',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://www.ownersemail.com/firebasestorage.googleapis.com/v0/b/owners-production-361612.appspot.com/o/airtable-assets/bdc7ff51-2d0b-47bc-b428-c646caff7f792c03.webp?alt=media&token=fb621e96-119a-486d-bf99-ed0dad2a8966',
        alt: 'AA Natural Landscaping Corp Team',
      },
      aboutText: [
        'AA Natural Landscaping Corp is a family-owned and locally operated business in Miami Gardens, FL. We are dedicated to providing top-notch landscaping services, focusing on customer satisfaction and attention to detail.',
        'Our team of skilled professionals brings years of experience to every project, ensuring that your outdoor spaces are not only beautiful but also functional and sustainable.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'AA Natural Landscaping Corp Logo',
      businessName: 'AA Natural Landscaping Corp',
      contact: {
        phone: '7864134932',
        phoneLabel: '(786) 413-4932',
        email: 'aanaturallandscapingcorp@gmail.com',
        website: 'https://aanaturallandscaping.com/',
        address: '116 NE 78th Street, Miami, FL 33138',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/profile.php?id=61555142454922&mibextid=LQQJ4d',
        instagram: 'https://www.instagram.com/aanaturallascapingcorp?igsh=NGVhN2U2NjQ0Yg==',
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '116 NE 78th Street, Miami, FL 33138',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3620.123456789012!2d-80.1234567!3d25.1234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b1234567890%3A0xabcdef1234567890!2s116+NE+78th+Street%2C+Miami%2C+FL+33138!5e0!3m2!1sen!2sus!4v1710412345678!5m2!1sen!2sus',
    },
  },
};

export default config;
